<template>
    <div>
        <vue-scroll :ops="$ops">
            <div style="height: 750px">
                <el-form :model="$parentInfo.dialog_ChangeInformation.student"
                         label-width="90px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="姓名">
                                <el-input v-model="$parentInfo.dialog_ChangeInformation.student.name"
                                          placeholder="请输入姓名"
                                          class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="性别">
                                <div style="margin: 5px 2px 3px 0;">
                                    <el-radio-group v-model="$parentInfo.dialog_ChangeInformation.student.gender_id">
                                        <el-radio :label="1">男生</el-radio>
                                        <el-radio :label="2">女生</el-radio>
                                    </el-radio-group>
                                </div>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="学校">
                                <el-select
                                        v-model="$parentInfo.dialog_ChangeInformation.student.current_education.school.id"
                                        filterable
                                        remote
                                        :remote-method="handleSearchSchool"
                                        :disabled=true
                                        placeholder="请选择学校"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.schools"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>


                        <el-col :span="12">
                            <el-form-item label="年级">
                                <el-select
                                        v-model="$parentInfo.dialog_ChangeInformation.student.current_education.grade.id"
                                        align="right"
                                        :disabled="true"
                                        placeholder="在读年级"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.grades"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="班级">
                                <el-select
                                        v-model="$parentInfo.dialog_ChangeInformation.student.current_education.schoolClass.id"
                                        align="right"
                                        :disabled="true"
                                        placeholder="在读班级"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.schoolClasses"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="班主任">
                                <el-select v-model="$parentInfo.dialog_ChangeInformation.student.headTeachers"
                                           multiple remote :remote-method="handleSearchHeadTeacher"
                                           placeholder="请选择班主任"
                                           class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.headTeachers"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="生日">
                                <el-date-picker
                                        v-model="$parentInfo.dialog_ChangeInformation.student.birthday"
                                        type="date"
                                        width="180"
                                        value-format="yyyy-MM-dd"
                                        placeholder="请选择学生生日"
                                        class="inputWidth">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="所选科目">
                                <el-select v-model="$parentInfo.dialog_ChangeInformation.student.subjects"
                                           multiple
                                           placeholder="请选择"
                                           class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.subjects"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="学生手机">
                                <el-input v-model="$parentInfo.dialog_ChangeInformation.student.phone"
                                          placeholder="联系方式"
                                          class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="学生微信">
                                <el-input v-model="$parentInfo.dialog_ChangeInformation.student.wechat"
                                          placeholder="联系方式"
                                          class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="学生QQ">
                                <el-input v-model="$parentInfo.dialog_ChangeInformation.student.qq" placeholder="联系方式"
                                          class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="星级">
                                <el-rate v-model="$parentInfo.dialog_ChangeInformation.student.star" :max="3" show-score
                                         text-color="#ff9900"></el-rate>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="m-separator m-separator--space m-separator--dashed"></div>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="渠道">
                                <el-select v-model="$parentInfo.dialog_ChangeInformation.student.promotion_channel_ids"
                                           multiple placeholder="请选择渠道"
                                           style="width:180px">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.promotion_channels"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="$parentInfo.dialog_ChangeInformation.student.promotion_channel_ids.includes(1)">
                        <el-col :span="10">
                            <el-form-item label="推荐人">
                                <el-select v-model="$parentInfo.dialog_ChangeInformation.student.referrer_id"
                                           placeholder="推荐人"
                                           class="inputWidth"
                                           filterable
                                           remote
                                           clearable
                                           :remote-method="handleSearchStudent"
                                           :disabled="!powers.includes(143)">
                                    <el-option
                                            v-for="(item,index) in $parentInfo.students"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="推荐人类型">
                                <el-radio-group v-model="$parentInfo.dialog_ChangeInformation.student.referrer_type"
                                                :disabled="!powers.includes(143)">
                                    <el-radio-button label="家长"></el-radio-button>
                                    <el-radio-button label="学生"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" v-if="$parentInfo.dialog_ChangeInformation.student.referrer_id">
                            <el-form-item label="">
                                <el-checkbox v-model="$parentInfo.dialog_ChangeInformation.student.conversion"
                                             v-if="$parentInfo.dialog_ChangeInformation.student.conversion"
                                             :disabled="!powers.includes(156)">参与团报</el-checkbox>
                                <el-checkbox v-model="$parentInfo.dialog_ChangeInformation.student.conversion"
                                             v-else>参与团报</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="$parentInfo.dialog_ChangeInformation.student.promotion_channel_ids.includes(6)">
                        <el-col :span="12">
                            <el-form-item label="其他">
                                <el-input v-model="$parentInfo.dialog_ChangeInformation.student.other_channel_remark" placeholder="请输入"  style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div class="m-separator m-separator--space m-separator--dashed"></div>
                    <el-form-item
                            v-for="(parent, index) in $parentInfo.dialog_ChangeInformation.student.parents"
                            label-width="0"
                            :key="index">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="家长身份">
                                    <el-select v-model="parent.parent_identity" placeholder="请选择家长身份"
                                               class="inputWidth">
                                        <el-option
                                                v-for="item in $parentInfo.initInformation.parent_identity"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="家长姓名">
                                    <el-input v-model="parent.name" placeholder="请输入家长姓名" class="inputWidth"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="家长电话">
                                    <el-input v-model="parent.phone" placeholder="联系方式" class="inputWidth"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" align="right">
                                <el-form-item>
                                    <el-button @click="handleAddParent">新增家长</el-button>
                                    <el-button @click="handleRemoveParent(parent)"
                                               v-if="index!=0">
                                        删除
                                    </el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
        </vue-scroll>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateStudentInformation"
                       :loading="$parentInfo.dialog_ChangeInformation.button_loading">保 存
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Dialog_ChangeInformation',
        data() {
            return {
                activeTab: 1,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleSearchStudent('');
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
        },
        methods: {
            handleSearchSchool(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type': 'searchSchool',
                    'schoolKeyName': query,
                });
            },
            handleSearchStudent(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type': 'searchStudent',
                    'studentKeyName': query,
                    'referrer_id': this.$parentInfo.dialog_ChangeInformation.student.referrer_id,
                });
            },
            handleUpdateStudentInformation() {
                let star = '';
                this.$parentInfo.dialog_ChangeInformation.button_loading = true;
                if (this.$parentInfo.dialog_ChangeInformation.student.birthday !== '' && this.$parentInfo.dialog_ChangeInformation.student.birthday != null) {
                    this.$parentInfo.dialog_ChangeInformation.student.birthday = this.$moment(this.$parentInfo.dialog_ChangeInformation.student.birthday).format('YYYY-MM-DD');
                }
                if (this.$parentInfo.dialog_ChangeInformation.student.star) {
                    star = this.$parentInfo.dialog_ChangeInformation.student.star;
                }
                this.$wApi.send(this.$parentInfo.path, 'updateStudentInformation', {
                    'student_id': this.$parentInfo.student_id,
                    'name': this.$parentInfo.dialog_ChangeInformation.student.name,
                    'gender_id': this.$parentInfo.dialog_ChangeInformation.student.gender_id,
                    'birthday': this.$parentInfo.dialog_ChangeInformation.student.birthday,
                    'phone': this.$parentInfo.dialog_ChangeInformation.student.phone,
                    'qq': this.$parentInfo.dialog_ChangeInformation.student.qq,
                    'wechat': this.$parentInfo.dialog_ChangeInformation.student.wechat,
                    'parents': this.$parentInfo.dialog_ChangeInformation.student.parents,
                    'subjects': this.$parentInfo.dialog_ChangeInformation.student.subjects,
                    'star': star,
                    'admission_text': '',
                    'headTeachers': this.$parentInfo.dialog_ChangeInformation.student.headTeachers,
                    'current_education': this.$parentInfo.dialog_ChangeInformation.student.current_education,
                    'referrer_id': this.$parentInfo.dialog_ChangeInformation.student.referrer_id,
                    'referrer_type': this.$parentInfo.dialog_ChangeInformation.student.referrer_type,
                    'promotion_channel_ids': this.$parentInfo.dialog_ChangeInformation.student.promotion_channel_ids,
                    'other_channel_remark': this.$parentInfo.dialog_ChangeInformation.student.other_channel_remark,
                    'conversion': this.$parentInfo.dialog_ChangeInformation.student.conversion,
                });
            },
            handleRemoveParent(item) {
                let index = this.$parentInfo.dialog_ChangeInformation.student.parents.indexOf(item);
                if (index !== -1) {
                    this.$parentInfo.dialog_ChangeInformation.student.parents.splice(index, 1)
                }
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type': 'headTeacherName',
                    'headTeacherName': query,
                });
            },
            handleAddParent() {
                this.$parentInfo.dialog_ChangeInformation.student.parents.push({
                    id: 0,
                    identity: '',
                    name: '',
                    phone: '',
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }

    .inputWidth {
        width: 180px !important;
    }
</style>
